/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MeLikeAlbumResponse } from "./MeLikeAlbumResponse";

export type MeLikeAlbumResponseApiRespoonse = {
  data?: MeLikeAlbumResponse;
  status?: MeLikeAlbumResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MeLikeAlbumResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
